import React from 'react'
import PropTypes from 'prop-types'

import styles from './tasteProfileMatchBadge.css'

const TasteProfileMatchBadge = ({ match }) => {
  if (!match) {
    return null
  }

  return (
    <div className={styles.percentageMatch}>
      <div className={styles.percentage}>{match}%</div>
      <div className={styles.percentageLabel}>match</div>
    </div>
  )
}

TasteProfileMatchBadge.propTypes = {
  match: PropTypes.number
}

TasteProfileMatchBadge.defaultProps = {
  match: null
}

export default TasteProfileMatchBadge
